<si-navbar-primary [account]="userData" [accountItems]="accountItems" navAriaLabel="Primary">

  <si-navbar-item *ngIf="isGlobalAdmin" quickAction [item]="askAiQuickAction">
  </si-navbar-item>
  <si-navbar-item quickAction [item]="themeToggleQuickAction">
   </si-navbar-item>
  <si-navbar-item quickAction [item]="{ title: 'Help', icon: 'element-help', items: helpItems }">
  </si-navbar-item>
</si-navbar-primary>
